import { ComboBox, IComboBox, IComboBoxOption, Label, Persona, PrimaryButton } from "@fluentui/react";
import { IpanelGeneric } from "../../../Interfaces/IPanel";
import { useCallback, useEffect, useRef, useState } from "react";
import { IOptionPersona } from "../../../Interfaces/IListaVerificacion";
import { ISearch } from "../../../Interfaces/base/IBase";
import ListaVerificacionService from "../../../services/listaVerificacionService";
import { IPersona } from "../../../Interfaces/IPersona";
import { useParams } from "react-router-dom";

interface FormAsignacionProps {

}

export function FormAsignacion({ childToParent }) {
    let { id } = useParams()
    const comboBoxRef = useRef<IComboBox>(null);
    const [model, setmodel] = useState<IFormModel>(INITIAL_MODEL);
    const [persona, setPersona] = useState<IOptionPersona[]>([]);
    const _openOptionPersona = useCallback(() => comboBoxRef.current?.focus(true), []);
    const [filterPersona, setFilterPersona] = useState<ISearch>({ search: null });

    useEffect(() => {
        dataPersona()
    }, []);

    useEffect(() => {
        dataPersona()
    }, [filterPersona]);

    const dataPersona = () => {
        ListaVerificacionService.personaByCustomer(filterPersona)
            .then(res => {
                /* v2 persona */
                let d: IPersona[] = res.data.data;
                let t: IOptionPersona[] = d.map(x => {
                    return ({
                        key: x.id,
                        text: `${x.nroDOI} | ${x.persona}`,
                        foto: x.foto,
                        doi: x.nroDOI,
                        puesto: x.puesto,
                    });
                });
                console.log("Data Combo Persona : ", t)

                setPersona(t);
            })
            .catch((e: Error) => {
                alert(e.message);
            });;
    }

    const _onUpPersona = (ev?) => {
        _openOptionPersona();
        let { value } = ev?.target as HTMLInputElement;
        setFilterPersona({
            ...filterPersona,
            search: value,
        });
    };

    const _onChangePersona = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string) => {
        if (event != undefined) {
            if (option != undefined) {
                setmodel({
                    ...model,
                    personaId: option.key.toString(),                
                });
                childToParent({
                    ...model,
                    personaId: option.key.toString(),
                    equipoModeloId: id
                });

            }
        }
    };


    return (
        <>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <ComboBox
                    componentRef={comboBoxRef}
                    label="Persona"
                    allowFreeform
                    autoComplete='off'
                    useComboBoxAsMenuWidth
                    calloutProps={{ directionalHintFixed: true }}
                    options={persona}
                    onInput={_onUpPersona}
                    selectedKey={model.personaId}
                    onChange={_onChangePersona}
                    required />
            </div>
        </>
    );
}

const PanelGenericoProps: IpanelGeneric = {
    HeaderTitlesText: {
        title: "Asignacion de personal",
        subTitle: "Seleccione persona para asignar"
    },
    textRegister: "Asignar"
}


interface IFormModel {
    personaId?: string,
    equipoModeloId?: string,
}

const INITIAL_MODEL = {
    personaId: '',
    equipoModeloId: '',
}

/**EJEMPLO DE COMUNICAICON CHILD TO PARENT */
// export default function Child({ childToParent }) {
//     const data = "This is data from Child Component to the Parent Component."
//     return (
//         <div>
//             <PrimaryButton primary onClick={() => childToParent(data)}>Click Child</PrimaryButton>
//         </div>
//     )
// }